"use client";

import { cva } from "class-variance-authority";
import { clsx } from "clsx";

const badgeVariants = cva(
  // Base styles
  [
    "inline-flex items-center justify-center font-medium transition-colors",
    "focus:outline-none focus:ring-2 focus:ring-offset-2",
  ],
  {
    variants: {
      variant: {
        default: "bg-background-300 text-foreground",
        primary: "bg-primary text-white",
        secondary: "bg-primary-weak text-primary",
        promo: "bg-promo-weak text-promo",
        tertiary: "bg-tertiary text-white",
        success: "bg-teal-weak text-teal",
        warning: "bg-warning-weak text-warning-strong",
        danger: "bg-danger-weak text-danger-strong",
        info: "bg-background-200 border border-border-weak text-foreground",
        emphasis: "bg-info-weak text-info-emphasis",
        attention: "bg-attention-weak text-attention-strong",
        muted: "bg-background-400 text-foreground-muted",
        outline: "border border-border bg-transparent text-foreground",
        ghost: "bg-transparent text-foreground-muted",
        plain: "bg-white text-info",
        subtle: " bg-info-weaker text-info-emphasis",
      },
      size: {
        xs: "px-2 py-0.5 text-xs rounded-sm",
        sm: "px-2 py-1.5 text-xs rounded-md font-medium",
        md: "px-3 py-1.5 text-sm rounded-lg",
        lg: "px-4 py-2 text-base rounded-lg",
      },
      shape: {
        rounded: "", // default rounded
        pill: "rounded-full",
        square: "rounded-none",
      },
    },
    compoundVariants: [
      // Focus ring variants
      {
        variant: "primary",
        class: "focus:ring-primary",
      },
      {
        variant: "secondary",
        class: "focus:ring-secondary",
      },
      {
        variant: "promo",
        class: "focus:ring-promo",
      },
      {
        variant: "tertiary",
        class: "focus:ring-tertiary",
      },
      {
        variant: "success",
        class: "focus:ring-success",
      },
      {
        variant: "warning",
        class: "focus:ring-warning",
      },
      {
        variant: "danger",
        class: "focus:ring-danger",
      },
      {
        variant: "info",
        class: "focus:ring-info",
      },
      {
        variant: "emphasis",
        class: "focus:ring-emphasis",
      },
      {
        variant: "attention",
        class: "focus:ring-attention",
      },
      {
        variant: "outline",
        class: "focus:ring-foreground",
      },
      {
        variant: "ghost",
        class: "focus:ring-foreground",
      },
      {
        variant: "default",
        class: "focus:ring-foreground",
      },
      {
        variant: "muted",
        class: "focus:ring-foreground",
      },
    ],
    defaultVariants: {
      variant: "default",
      size: "md",
      shape: "rounded",
    },
  },
);

export default function Badge({
  children,
  variant = "default",
  size = "md",
  shape = "rounded",
  className,
  ...props
}) {
  return (
    <span
      className={clsx(badgeVariants({ variant, size, shape }), className)}
      {...props}
    >
      {children}
    </span>
  );
}
